import { CheckCircleOutlined, ExclamationCircleFilled, ReloadOutlined, StopOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import React from 'react'
import DerogationUtilisateur from './DerogationUtilisateur';
import ChangeProfilUtilisateur from './ChangeProfilUtilisateur';
import ChangeAgenceUtilisateur from './ChangeAgenceUtilisateur';
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import { isConnectedUserFromPOOL } from '../../../variables/functions';
import { LOGGED_USER } from '../../../variables/constants';

const { confirm } = Modal;

const SecuriteUtilisateur = ({ utilisateur, requireActive, infoButtonStyle, buttonStyle, dangerButtonStyle, successButtonStyle, showReinitialisationConfirm, modules, habilitations, navigate, param, profils }) => {
    const isPoolUser = isConnectedUserFromPOOL();
    const isAdminProfile = ((LOGGED_USER?.profil?.nom || "")).toLowerCase().includes("admin");
    const hasSecurityPrivileges = isPoolUser || isAdminProfile;
    const isSelfTarget = Boolean(
        (LOGGED_USER?.codeId && utilisateur?.codeId && LOGGED_USER.codeId === utilisateur.codeId)
        || (LOGGED_USER?.email && utilisateur?.email && LOGGED_USER.email === utilisateur.email)
        || (LOGGED_USER?.username && utilisateur?.username && LOGGED_USER.username === utilisateur.username)
    );

    // Sécurité: seules les actions faites par le Pool sur d'autres utilisateurs sont autorisées côté UI.
    const lockReason = isSelfTarget ? "self" : (!hasSecurityPrivileges ? "insufficient" : null);
    const isSecurityLocked = lockReason !== null;
    const poolContactMessage = "Action réservée au Pool / Admin. Contactez-les pour procéder.";
    const selfLockMessage = "Action de sécurité interdite sur votre propre compte. Contactez le POOL";
    const securityLockMessage = lockReason === "insufficient" ? poolContactMessage : (lockReason === "self" ? selfLockMessage : null);

    const notifySecurityLocked = () => toast(securityLockMessage || poolContactMessage);

    const disabledButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    const showUserActivateConfirm = (utilisateurCodeId, status) => {
        confirm({
            title: status
                ? "Etes-vous sûr de vouloir désactiver cet utilisateur?"
                : "Etes-vous sûr de vouloir activer cet utilisateur?",
            icon: <ExclamationCircleFilled />,
            content: "Cette action sera historisée et donc est irréversible",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                activateUtilisateur(utilisateurCodeId, status);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const activateUtilisateur = (utilisateurCodeId, status) => {
        axiosInstance
            .get(`/api/utilisateur/activate/${utilisateurCodeId}`)
            .then((res) => {
                // console.log(res.data);
                navigate(`/details-utilisateur/${res.data.codeId}`);
                toast(
                    status
                        ? "Utilisateur désactivé avec succès"
                        : "Utilisateur activé avec succès"
                );
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de l'activation");
            });
    };

    return (
        <div style={{ padding: '24px' }}>
            {securityLockMessage && lockReason === "insufficient" && (
                <div className="alert alert-warning d-flex align-items-center" role="alert" style={{ gap: '8px', marginBottom: '16px' }}>
                    <ExclamationCircleFilled style={{ color: '#d48806' }} />
                    <span>Self-service désactivé : {securityLockMessage}</span>
                </div>
            )}
            {securityLockMessage && lockReason === "self" && (
                <div className="alert alert-warning d-flex align-items-center" role="alert" style={{ gap: '8px', marginBottom: '16px' }}>
                    <ExclamationCircleFilled style={{ color: '#d48806' }} />
                    <span>{securityLockMessage}</span>
                </div>
            )}
            <div style={{
                backgroundColor: '#F7F9FB',
                borderRadius: '12px',
                padding: '32px',
                border: '2px solid #E6F0FF'
            }}>
                <h3 style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#242166',
                    marginBottom: '12px'
                }}>
                    Gestion des accès et permissions
                </h3>
                <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '32px' }}>
                    Gérez les permissions, le profil et les droits spéciaux de l'utilisateur
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    {/* Dérogation */}
                    <DerogationUtilisateur
                        utilisateur={utilisateur}
                        requireActive={requireActive}
                        infoButtonStyle={infoButtonStyle}
                        modules={modules}
                        habilitations={habilitations}
                        navigate={navigate}
                        param={param}
                        isSecurityLocked={isSecurityLocked}
                        securityLockMessage={securityLockMessage}
                    />

                    {/* Changer profil */}
                    <ChangeProfilUtilisateur
                        utilisateur={utilisateur}
                        buttonStyle={buttonStyle}
                        profils={profils}
                        param={param}
                        navigate={navigate}
                        requireActive={requireActive}
                        isSecurityLocked={isSecurityLocked}
                        securityLockMessage={securityLockMessage}
                    />

                    {/* Changer agence */}
                    <ChangeAgenceUtilisateur
                        utilisateur={utilisateur}
                        buttonStyle={buttonStyle}
                        navigate={navigate}
                        param={param}
                        requireActive={requireActive}
                        isSecurityLocked={isSecurityLocked}
                        securityLockMessage={securityLockMessage}
                    />

                    {/* Réinitialiser */}
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        border: '2px solid #FEE2E2',
                        transition: 'all 0.3s ease'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '12px',
                                backgroundColor: '#FEE2E2',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <ReloadOutlined style={{ fontSize: '24px', color: '#DC2626' }} />
                            </div>
                            <div>
                                <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#242166', margin: 0 }}>
                                    Réinitialisation
                                </h4>
                                <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>
                                    Compte utilisateur
                                </p>
                            </div>
                        </div>
                        <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
                            Réinitialisez le mot de passe de l'utilisateur
                        </p>
                        {securityLockMessage && (
                            <p style={{ fontSize: '12px', color: '#b45309', marginBottom: '12px' }}>
                                {securityLockMessage}
                            </p>
                        )}
                        <Button
                            icon={<ReloadOutlined />}
                            block
                            disabled={!utilisateur?.active || isSecurityLocked}
                            style={!utilisateur?.active || isSecurityLocked ? { ...dangerButtonStyle, ...disabledButtonStyle } : dangerButtonStyle}
                            onClick={() => {
                                if (isSecurityLocked) {
                                    notifySecurityLocked();
                                    return;
                                }
                                showReinitialisationConfirm(utilisateur?.email);
                            }}
                        >
                            Réinitialiser le compte
                        </Button>
                    </div>
                </div>
            </div>

            {/* Section Activation/Désactivation */}
            <div style={{
                backgroundColor: utilisateur?.active ? '#FEE2E2' : '#D1FAE5',
                borderRadius: '12px',
                padding: '32px',
                border: `2px solid ${utilisateur?.active ? '#FCA5A5' : '#6EE7B7'}`
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
                    <div style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '12px',
                        backgroundColor: utilisateur?.active ? '#DC2626' : '#10B981',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {utilisateur?.active ? (
                            <StopOutlined style={{ fontSize: '28px', color: 'white' }} />
                        ) : (
                            <CheckCircleOutlined style={{ fontSize: '28px', color: 'white' }} />
                        )}
                    </div>
                    <div style={{ flex: 1 }}>
                        <h3 style={{
                            fontSize: '20px',
                            fontWeight: '700',
                            color: '#242166',
                            marginBottom: '8px'
                        }}>
                            {utilisateur?.active ? "Zone de danger" : "Réactiver l'utilisateur"}
                        </h3>
                        <p style={{
                            fontSize: '14px',
                            color: utilisateur?.active ? '#7F1D1D' : '#064E3B',
                            margin: 0
                        }}>
                            {utilisateur?.active
                                ? "La suspension empêchera l'utilisateur d'accéder au système. Cette action est irréversible et sera historisée."
                                : "Réactivez cet utilisateur pour lui redonner accès au système."
                            }
                        </p>
                    </div>
                </div>
                <Button
                    danger={utilisateur?.active}
                    icon={utilisateur?.active ? <StopOutlined /> : <CheckCircleOutlined />}
                    size="large"
                    disabled={isSecurityLocked}
                    style={
                        isSecurityLocked
                            ? { ...disabledButtonStyle, width: '100%' }
                            : utilisateur?.active
                                ? { ...dangerButtonStyle, width: '100%' }
                                : { ...successButtonStyle, width: '100%' }
                    }
                    onClick={() => {
                        if (isSecurityLocked) {
                            notifySecurityLocked();
                            return;
                        }
                        showUserActivateConfirm(utilisateur.codeId, utilisateur.active);
                    }}
                >
                    {utilisateur?.active ? "Suspendre l'utilisateur" : "Activer l'utilisateur"}
                </Button>
            </div>
        </div>
    )
}

export default SecuriteUtilisateur
